import { render } from "./ExhibitCard.vue?vue&type=template&id=d8ce5540"
import script from "./ExhibitCard.vue?vue&type=script&lang=js"
export * from "./ExhibitCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__